/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetExcelConfiguration', 'model/SheetExcelGenerationSettings', 'model/ExternalSourceLightSpreadsheet', 'model/FileTransferHelperEntity', 'model/PerformanceIndicatorDataReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SheetExcelConfiguration'), require('../model/SheetExcelGenerationSettings'), require('../model/ExternalSourceLightSpreadsheet'), require('../model/FileTransferHelperEntity'), require('../model/PerformanceIndicatorDataReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetExcelConfigurationApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetExcelConfiguration, root.ForStractionServiceApi.SheetExcelGenerationSettings, root.ForStractionServiceApi.ExternalSourceLightSpreadsheet, root.ForStractionServiceApi.FileTransferHelperEntity, root.ForStractionServiceApi.PerformanceIndicatorDataReport);
  }
}(this, function(ApiClient, SheetExcelConfiguration, SheetExcelGenerationSettings, ExternalSourceLightSpreadsheet, FileTransferHelperEntity, PerformanceIndicatorDataReport) {
  'use strict';

  /**
   * SheetExcelConfiguration service.
   * @module api/SheetExcelConfigurationApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SheetExcelConfigurationApi. 
   * @alias module:api/SheetExcelConfigurationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sheetExcelConfigurationAddPut operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetExcelConfiguration} body 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.sheetExcelConfigurationAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetExcelConfigurationAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationCheckAuthenticationGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCheckAuthenticationGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkAuthentication
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetExcelConfigurationID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCheckAuthenticationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.sheetExcelConfigurationCheckAuthenticationGet = function(_4SAPIAppID, sheetExcelConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationCheckAuthenticationGet";
      }

      // verify the required parameter 'sheetExcelConfigurationID' is set
      if (sheetExcelConfigurationID == undefined || sheetExcelConfigurationID == null) {
        throw "Missing the required parameter 'sheetExcelConfigurationID' when calling sheetExcelConfigurationCheckAuthenticationGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetExcelConfigurationID': sheetExcelConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/checkAuthentication', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationCreateExcelFilePut operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCreateExcelFilePutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createExcelFile
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetExcelGenerationSettings} body 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCreateExcelFilePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.sheetExcelConfigurationCreateExcelFilePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationCreateExcelFilePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetExcelConfigurationCreateExcelFilePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/createExcelFile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationCreateFromShareURLGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCreateFromShareURLGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetExcelConfiguration} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createFromShareURL
     * @param {String} _4SAPIAppID 
     * @param {String} shareURL 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationCreateFromShareURLGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetExcelConfiguration}
     */
    this.sheetExcelConfigurationCreateFromShareURLGet = function(_4SAPIAppID, shareURL, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationCreateFromShareURLGet";
      }

      // verify the required parameter 'shareURL' is set
      if (shareURL == undefined || shareURL == null) {
        throw "Missing the required parameter 'shareURL' when calling sheetExcelConfigurationCreateFromShareURLGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'shareURL': shareURL
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetExcelConfiguration;

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/createFromShareURL', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationDeleteGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetExcelConfigurationDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling sheetExcelConfigurationDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationEditPut operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetExcelConfiguration} body 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetExcelConfigurationEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetExcelConfigurationEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationGetExcelSpreadsheetGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationGetExcelSpreadsheetGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ExternalSourceLightSpreadsheet} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getExcelSpreadsheet
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetExcelConfigurationID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationGetExcelSpreadsheetGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ExternalSourceLightSpreadsheet}
     */
    this.sheetExcelConfigurationGetExcelSpreadsheetGet = function(_4SAPIAppID, sheetExcelConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationGetExcelSpreadsheetGet";
      }

      // verify the required parameter 'sheetExcelConfigurationID' is set
      if (sheetExcelConfigurationID == undefined || sheetExcelConfigurationID == null) {
        throw "Missing the required parameter 'sheetExcelConfigurationID' when calling sheetExcelConfigurationGetExcelSpreadsheetGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetExcelConfigurationID': sheetExcelConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ExternalSourceLightSpreadsheet;

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/getExcelSpreadsheet', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationImportAndProcessExcelFilePut operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationImportAndProcessExcelFilePutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importAndProcessExcelFile
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} sheetExcelConfigurationID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationImportAndProcessExcelFilePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDataReport>}
     */
    this.sheetExcelConfigurationImportAndProcessExcelFilePut = function(_4SAPIAppID, body, sheetExcelConfigurationID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationImportAndProcessExcelFilePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetExcelConfigurationImportAndProcessExcelFilePut";
      }

      // verify the required parameter 'sheetExcelConfigurationID' is set
      if (sheetExcelConfigurationID == undefined || sheetExcelConfigurationID == null) {
        throw "Missing the required parameter 'sheetExcelConfigurationID' when calling sheetExcelConfigurationImportAndProcessExcelFilePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetExcelConfigurationID': sheetExcelConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDataReport];

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/importAndProcessExcelFile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationLoadAllGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SheetExcelConfiguration>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SheetExcelConfiguration>}
     */
    this.sheetExcelConfigurationLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [SheetExcelConfiguration];

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationLoadGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetExcelConfiguration} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetExcelConfiguration}
     */
    this.sheetExcelConfigurationLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling sheetExcelConfigurationLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetExcelConfiguration;

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationReprocessStoredExcelFileGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationReprocessStoredExcelFileGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * reprocessStoredExcelFile
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetExcelConfigurationID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationReprocessStoredExcelFileGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDataReport>}
     */
    this.sheetExcelConfigurationReprocessStoredExcelFileGet = function(_4SAPIAppID, sheetExcelConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationReprocessStoredExcelFileGet";
      }

      // verify the required parameter 'sheetExcelConfigurationID' is set
      if (sheetExcelConfigurationID == undefined || sheetExcelConfigurationID == null) {
        throw "Missing the required parameter 'sheetExcelConfigurationID' when calling sheetExcelConfigurationReprocessStoredExcelFileGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetExcelConfigurationID': sheetExcelConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDataReport];

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/reprocessStoredExcelFile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeExcelFileAndSetURIToConfiguration
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} sheetExcelConfigurationID 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut = function(_4SAPIAppID, body, sheetExcelConfigurationID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut";
      }

      // verify the required parameter 'sheetExcelConfigurationID' is set
      if (sheetExcelConfigurationID == undefined || sheetExcelConfigurationID == null) {
        throw "Missing the required parameter 'sheetExcelConfigurationID' when calling sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetExcelConfigurationID': sheetExcelConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/storeExcelFileAndSetURIToConfiguration', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetExcelConfigurationTestShareURLGet operation.
     * @callback module:api/SheetExcelConfigurationApi~sheetExcelConfigurationTestShareURLGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * testShareURL
     * @param {String} _4SAPIAppID 
     * @param {String} shareURL 
     * @param {module:api/SheetExcelConfigurationApi~sheetExcelConfigurationTestShareURLGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.sheetExcelConfigurationTestShareURLGet = function(_4SAPIAppID, shareURL, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetExcelConfigurationTestShareURLGet";
      }

      // verify the required parameter 'shareURL' is set
      if (shareURL == undefined || shareURL == null) {
        throw "Missing the required parameter 'shareURL' when calling sheetExcelConfigurationTestShareURLGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'shareURL': shareURL
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/SheetExcelConfiguration/testShareURL', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
